<template>
  <div class="card">
    <div class="card-header">
      <van-row class="info">
        <van-col span="12">
          <span class="info-title">交货单</span>
          <span>:</span>
          <span class="info-value">rrrrr</span>
        </van-col>
        <van-col span="12">
          <span class="info-title">创建时间</span>
          <span>:</span>
          <span class="info-value"></span>
        </van-col>
      </van-row>
   
    </div>
    <div class="card-info van-hairline--top">
      <van-row class="info">
        <van-col span="24">
          <span class="info-title">订单编号：</span>
          <span class="info-value">石家庄市**区**路**号</span>
        </van-col>
      </van-row>
      <van-row class="info">
        <van-col span="24">
          <span class="info-title">卖家名称：</span>
          <span class="info-value">石家庄市**区**路**号</span>
        </van-col>
      </van-row>
      <van-row class="info">
        <van-col span="24">
          <span class="info-title">送达方：</span>
          <span class="info-value">石家庄市**区**路**号</span>
        </van-col>
      </van-row>
      <van-row class="info">
        <van-col span="24">
          <span class="info-title">收货地址：</span>
          <span class="info-value">石家庄市**区**路**号</span>
        </van-col>
      </van-row>
      <van-row class="info">
        <van-col span="12">
          <span class="info-title">计划发货日期：</span>
          <span class="info-value">中石油华北销售公司</span>
        </van-col>
        <van-col span="12">
          <span class="info-title">实际发货日期</span>
          <span>：</span>
          <span class="info-value">石家庄仓库</span>
        </van-col>
      </van-row>
      <van-row class="info">
        <van-col span="12">
          <span class="info-title">装运条件</span>
          <span>：</span>
          <span class="info-value">直发</span>
        </van-col>
        <van-col span="12">
          <span class="info-title">装运类型</span>
          <span>：</span>
          <span class="info-value">自提</span>
        </van-col>
      </van-row>
      <van-row class="info">
        <van-col span="12">
          <span class="info-title">发站</span>
          <span>：</span>
          <span class="info-value"> 吨</span>
        </van-col>
        <van-col span="12">
          <span class="info-title">到站</span>
          <span>：</span>
          <span class="info-value">30</span>
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
// import orderApi from "@/request/orderApi";
export default {
  name: "LogisticsCard",
  props: {
    // order: Object,
  },
  data() {
    return{

    }
   
  },
  computed: {
    statusCode() {
      return this.$store.state.valueSet;
    },
  
  },
  methods: {
    logisticsTracking(item) {
      //
      this.$router.push("/logisticsTracking?orderId=" + item.id);
      // this.$emit("cancelOrder", item);
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '~@/assets/styles/varibles.styl';

.card {
  margin-top: 24px;
  background: #ffffff;
  padding: 12px 24px;
  font-size: 26px;

  .card-header, .card-total, .card-info {
    padding: 12px 0;
  }

  .card-info, .card-total {
    color: #666666;
  }

  .info {
    line-height: 61px;

    .info-size700 {
      font-weight: 700;
      font-size: 26px;
      color: rgb(102, 102, 102);
    }

    .info-title {
      display: inline-block;
      min-width: 80px;
      text-align: justify;
      text-align-last: justify;
    }

    .info-value {
      margin-left: 16px;
    }

    .status {
      color: #3A70CC;
    }
  }

  .color-red {
    color: #E12020;
  }

  .large {
    font-size: 36px;
  }

  .card-btn {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    height: 120px;

    .btn {
      min-width: 200px;
      height: 72px;
      background: $gradientColor;
      color: #ffffff;
      font-size: 32px;
      border-radius: 40px;
    }
  }
}
</style>